<template>
    <div class="lesson">
        <div class="lesson-status">
            <slot name='top'></slot>
        </div>
        <is-empty size="small" :show="data.length > 0" message="暂时没有数据~">
            <div class="lesson-list">
                <el-row class="lesson-item" v-for="lesson in data" :key="lesson.lessonId">
                    <el-col class="lesson-main" :span="20">
                        <el-row class="lesson-info">
                            <el-col class="lesson-pic" :span="7">
                                <el-image fit="cover" :src="lesson.avatar | filterUrl">
                                    <div class="image-placeholder" slot="placeholder">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div class="image-error" slot="error">
                                        <i class="el-icon-picture-outline"></i>
                                    </div>
                                </el-image>
                            </el-col>
                            <el-col :span="17">
                                <div class="lesson-title">{{ lesson.lessonName }}</div>
                                <p class="lesson-synopsis">
                                    <span>任课教师：</span>
                                    <span>{{ lesson.teacher }}</span>
                                </p>
                                <p class="lesson-summary" v-text="lesson.summary"></p>
                                <div class="lesson-body">
                                    <span v-text="`创建时间：${lesson.createTime}`"></span>
                                    <span v-text="`实验：${lesson.labExpNum}`"></span>
                                    <span v-text="`作业：${lesson.labTaskNum}`"></span>
                                    <span v-text="`成员：${lesson.memberNum}`"></span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col class="lesson-action" :span="4">
                        <div class="top" v-if="canEdit">
                            <el-dropdown @command="handleClick($event, lesson.lessonId)" trigger="click">
                                <span class="el-dropdown-link">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 编辑</el-dropdown-item>
                                    <el-dropdown-item command="delete"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                                    <!-- <el-dropdown-item command="end"><i class="ultralab-icon-file-arrange"></i> 结课</el-dropdown-item> -->
                                    <!-- <el-dropdown-item><i class="ultralab-icon-copy"></i> 复制课堂</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="top" v-else>
                            <el-dropdown @command="handleClick($event, lesson.uid)" trigger="click">
                                <span class="el-dropdown-link">
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="out"><i class="el-icon-switch-button"></i> 退出课堂</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="bottom">
                            <el-button type="primary" size="small" @click="startLesson(lesson.uid)">开始上课</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </is-empty>
    </div>
</template>

<script>
import isEmpty from '@/components/common/is-empty'
export default {
    props: {
        type: {
            type: Number,
            default: 1
        },
        data: {
            type: Array
        },
        canEdit: {
            type: Boolean,
            default() { return true }
        }
    },
    components: {
        isEmpty
    },
    methods: {
        handleClick(op, id) {
            this.$emit(op, id)
        },
        /**
         *开始上课
        */
        startLesson(uid) {
            this.$router.push(`/lesson/${uid}/type/exp`);
        }
    }
}
</script>
